'use es6';

import { handleActions } from 'flux-actions';
const initialState = null;
export default handleActions({}, initialState);